import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Activate from '@/views/Activate.vue'
import Export from '@/views/Export.vue'
import ExportTaskList from '@/views/ExportTaskList.vue'
import AdminDashboard from '@/views/AdminDashboard.vue'
import ConfigManagement from '@/views/ConfigManagement.vue'
import CardManagement from '@/views/CardManagement.vue'
import ExportManagement from '@/views/ExportManagement.vue'
import AnnouncementManagement from '@/views/AnnouncementManagement.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Activate',
    component: Activate
  },
  {
    path: '/export',
    name: 'Export',
    component: Export
  },
  {
    path: '/export/tasks',
    name: 'ExportTaskList',
    component: ExportTaskList
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/config',
    name: 'ConfigManagement',
    component: ConfigManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/cards',
    name: 'CardManagement',
    component: CardManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/export',
    name: 'ExportManagement',
    component: ExportManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/announcements',
    name: 'AnnouncementManagement',
    component: AnnouncementManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 检查是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token')
    if (!token) {
      next('/login')
      return
    }
  }
  
  // 检查是否需要管理员权限
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const userRole = localStorage.getItem('userRole')
    if (userRole !== 'admin') {
      next('/')
      return
    }
  }
  
  next()
})

export default router 